<ion-header>
  <ion-toolbar>
    <div class="container">
      <div class="left-block">
        <ion-back-button
          [defaultHref]="defaultBackUrl"
          *ngIf="showBackButton"
          text=""
          icon="../../../assets/icon/back-button-light.svg"
        ></ion-back-button>
      </div>

      <div class="center-block">
        <h2>{{ headerData?.title }}</h2>
      </div>

      <div *ngIf="headerData" class="right-block">
        <div class="count">
          <h4>{{ headerData.totalCount }}</h4>
        </div>

        <div
          *ngIf="headerData.options"
          (click)="openRTCActions()"
          (keyup.enter)="openRTCActions()"
          (keydown.space)="openRTCActions()"
          class="options"
          tabindex="0"
          role="button"
          aria-label="Действия с РТС"
        >
          <ion-icon
            src="../../../assets/icon/options-icon-light.svg"
          ></ion-icon>
        </div>

        <div
          *ngIf="headerData.downloadOption"
          (click)="downloadDocument()"
          (keyup.enter)="downloadDocument()"
          (keydown.space)="downloadDocument()"
          class="ion-activatable ripple-parent circle"
          tabindex="0"
          role="button"
          aria-label="Скачать документ"
        >
          <ion-icon src="../../../assets/icon/download-icon.svg"></ion-icon>
          <ion-ripple-effect> </ion-ripple-effect>
        </div>
      </div>

      <div
        *ngIf="closableIcon"
        (click)="hideModalWindow()"
        (keyup.enter)="hideModalWindow()"
        (keydown.space)="hideModalWindow()"
        class="ion-activatable ripple-parent circle close-icon"
        tabindex="0"
        role="button"
        aria-label="Закрыть"
      >
        <img src="assets/icon/close-icon.svg" alt="Закрыть"/>
        <ion-ripple-effect> </ion-ripple-effect>
      </div>
    </div>
    <div *ngIf="headerData?.subtitle as subtitle" class="subtitle">
      <div class="green">{{ subtitle.cars }}</div>
      машин
      <div class="green">{{ subtitle.amount }}</div>
      кг
    </div>
    <div class="searchBar-container">
      <ion-searchbar
        class="light"
        *ngIf="showSearchBar"
        placeholder="Поиск"
        [(ngModel)]="searchbarValue"
        (ionFocus)="ionFocus()"
        (ionClear)="searchbarClear()"
      ></ion-searchbar>

      <div *ngIf="showActionButtons" class="actions">
        <ion-button
          (click)="showLoadingArchive()"
          [class.primary]="!loadingArchiveButtonIsPrimary"
          [class.secondary]="loadingArchiveButtonIsPrimary"
          class="square small left"
          mode="md"
          >Завершенные</ion-button
        >
        <ion-button
          (click)="showUnloadingArchive()"
          [class.primary]="!unloadingArchiveButtonIsPrimary"
          [class.secondary]="unloadingArchiveButtonIsPrimary"
          class="square small right"
          mode="md"
          >В пути</ion-button
        >
      </div>
    </div>
  </ion-toolbar>
</ion-header>
